<template>
  <div id="app">
    <navigation :class="$route.name" />
    <router-view/>
    <bonjour-footer/>
    <dialogs-wrapper></dialogs-wrapper>
  </div>
</template>

<script>
import BonjourFooter from './components/Footer.vue'
import Navigation from './components/Navigation.vue'


export default {
  name: 'App',
  components: {
    BonjourFooter,
    Navigation,
  },
  data() {
    return {
      route: ""
    }
    
  }
}
</script>

<style>
@import "./assets/css/resetr.css";
@import "./assets/css/prismic-edit-button.css";
</style>
